import { Box, Button, Typography, withStyles } from "@material-ui/core";
import React, { useEffect, useReducer } from "react";
import Styles from "../commonStyles";
import AuthContainer from "../_components/AuthContainer";
import CommonPopup from "../_components/CommonPopup";
import InputPaper from "../_components/InputPaper";
import config from "../_config/config";
import strings from "../_constants/strings";
import actions from "../_fpactions/fpswdactions";
import { getErrorMsg } from "../_helpers/errors";
import axios from "../_helpers/interceptor";
import { goToLogin } from "../_helpers/navHelpers";
import useEventCallback from "../_helpers/useEventCallBack";

function makeCall(data, isReset) {
  var dt = {
    payload: [data]
  };
  return axios.post(`${config.endpoint}${isReset ? config.resetpin : config.setpin}`, dt);
}

function reducerFunction(state, action) {
  const { ERRORS: { E_PIN } } = strings;
  switch (action.type) {
    case actions.ENTER_NEW_PIN:
      state.newpin = action.data;
      if (action.data && (action.data.length < 4 || action.data.length > 4)) {
        state.error = { newpin: E_PIN };
      } else {
        state.error = { newpin: "" };
      }
      return { ...state };
    case actions.CONFIRM_PIN:
      state.confirmpin = action.data;
      if (action.data && action.data !== state.newpin) {
        state.error = { confirmpin: "this pin must match with new pin " };
      } else {
        state.error = { confirmpin: "" };
      }
      return { ...state };
    case actions.SUBMIT_NEW_PIN:
      if (state.newpin === state.confirmpin) {
        action.Stagesetpin(state);
        return { ...state };
      } else {
        state.error = { newpin: "Please enter valid pin " };
        return { ...state };
      }
    case actions.NEW_PIN_SUBMIT_FAILURE:
      state.error = { msg: action.data };
      break;
    case actions.NEW_PIN_SUBMIT_SUCCESS:
      state.newpinSet = true;
      state.popup = true;
      return { ...state };
    case actions.POPUP_SUBMIT:
      state.popup = false;
      return { ...state };
  }
  return { ...state };
}

function SetPin(props) {
  const { MESSAGES: { PIN_SET_SUCCESS } } = strings;
  const {
    classes,
    match: {
      params: { step: propsStep }
    }, } = props;
  const [state, setState] = useReducer(reducerFunction, {
    newpin: "",
    error: {},
    confirmpin: "",
    popup: false,
    newpinSet: false
  });

  useEffect(() => {
    state && state.newpinSet && !state.popup && goToLogin(props.history);
  }, [state.popup]);

  const handlesetpinsubmit = e => {
    e && e.preventDefault();
    setState({ type: actions.SUBMIT_NEW_PIN, Stagesetpin: Stagesetpin });
  };
  const handlenewpin = e => {
    setState({
      type: actions.ENTER_NEW_PIN,
      data: e.target.value
    });
  };
  const handleconfirmpin = e => {
    setState({
      type: actions.CONFIRM_PIN,
      data: e.target.value
    });
  };

  const Stagesetpin = state => {
    makeCall({ pin: state.newpin, confirmPin: state.confirmpin }, propsStep)
      .then(useEventForSetPin)
      .catch(useEventForSetPin);
  };

  const SetpinrespFunc = resp => {
    if (resp && resp.data && resp.data.success) {
      setState({
        type: actions.NEW_PIN_SUBMIT_SUCCESS,
        data: resp.data.success
      });
    } else {
      setState({
        type: actions.NEW_PIN_SUBMIT_FAILURE,
        // data: resp && resp.data && resp.data.error && resp.data.error.errordesc ? resp.data.error.errordesc : "Somethin went wrong..."
        data: getErrorMsg(resp) || "Somethin went wrong..."
      });
    }
  };

  const handleClose = () => {
    setState({ type: actions.POPUP_SUBMIT });
  };

  const useEventForSetPin = useEventCallback(SetpinrespFunc, [state, setState]);
  return (
    <>
      <AuthContainer formtype="set pin">
        <Box className={classes.formBox}>
          <Typography gutterBottom className={classes.formtitle}>
            Set PIN
            </Typography>

          <Typography
            className={classes.errormsg}
            variant="caption"
            display="block"
            gutterBottom
          >
            {state.error.msg}
          </Typography>

          <InputPaper
            inputtype="number"
            value={state.newpin}
            name=" NewPin"
            placeholder="New Pin"
            error={state.error.newpin ? true : false}
            handler={handlenewpin}
          ></InputPaper>

          {state.error.newpin ? (
            <Typography
              className={classes.errormsg}
              variant="caption"
              display="block"
              gutterBottom
            >
              {state.error.newpin}
            </Typography>
          ) : (
              <Typography
                className={classes.infomsg}
                variant="caption"
                display="block"
                gutterBottom
              >
                Enter Your 4 Digit PIN
              </Typography>
            )}

          <InputPaper
            inputtype="confirmpin"
            value={state.confirmpin}
            name="confirmpin"
            placeholder="Confirm Pin"
            error={state.error.confirmpin ? true : false}
            handler={handleconfirmpin}
          ></InputPaper>

          <Typography
            className={classes.errormsg}
            variant="caption"
            display="block"
            gutterBottom
          >
            {state.error.confirmpin}
          </Typography>

          <Button
            type="submit"
            className={classes.loginbutton}
            onClick={handlesetpinsubmit}
          >
            Submit
            </Button>
        </Box>
      </AuthContainer>
      <CommonPopup
        openState={state.popup}
        popupText={PIN_SET_SUCCESS}
        handleClick={handleClose}
      />
    </>
  );
}
export default withStyles(Styles)(SetPin);
